import { GetStaticProps, GetStaticPropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export default function Custom404() {
    return <h2 className="text-center">404 - Page Not Found</h2>;
}

export const getStaticProps: GetStaticProps = async (
    ctx: GetStaticPropsContext
) => {
    return {
        props: {
            ...(await serverSideTranslations(ctx.locale as string, [
                "common",
                "spaces",
                "setUpSpaces",
                "profile",
                "language",
                "toast",
            ])),
        },
    };
};
